import templateUrl from "emun.payments/payment-method-manager.htm";
import controller from "emun.payments/payment-method-manager.controller";

/**
 * Payment Method Manager Component
 *
 * A secure payment method management component that integrates with HostedPCI
 * for tokenized credit card processing. Provides functionality to add, view,
 * select, and delete retailer payment methods.
 *
 * @component paymentMethodManager
 * @example
 * <payment-method-manager retailer-id="{{retailerId}}"></payment-method-manager>
 */
export default {
  bindings: {
    apiKey: "@", // The authentication token for API requests
    retailerId: "@", // The ID of the retailer whose payment methods to manage
    vendorId: "@", // The ID of the vendor associated with the payment methods
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },

  // Component lifecycle hooks for cleanup if needed
  $onDestroy() {
    // Clean up any event listeners or subscriptions
    if (this.controller && typeof this.controller.$onDestroy === "function") {
      this.controller.$onDestroy();
    }
  },
};
